import { render, staticRenderFns } from "./SupplierManufacturingHome.vue?vue&type=template&id=84856dbc&scoped=true&"
import script from "./SupplierManufacturingHome.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84856dbc",
  null
  
)

export default component.exports